exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-table-expand label[data-v-6689c8b6]{width:90px}.el-dropdown-link[data-v-6689c8b6]{cursor:pointer;color:#1890ff;font-size:12px}.el-icon-arrow-down[data-v-6689c8b6]{font-size:12px}.icon-arrow-down[data-v-6689c8b6]  .el-dropdown-menu__item{font-size:12px}", ""]);

// exports
